import NoteTypes from './noteTypes';

export default [
    NoteTypes.Thinkers,
    NoteTypes.Whiteboard,
    NoteTypes.Document
];
